import {
  Box,
  IconClear,
  IconHelp,
  Text,
  TooltipRenderer,
} from 'braid-design-system';
import { comparatorNames, filterTypesMap, specialConfigs } from './config.ts';
import type { FilterData } from './types.ts';
import { LightTag } from '#src/components/LightTag/LightTag.tsx';

export const FilterDisplay = ({
  filter,
  remove,
  edit,
}: {
  filter: FilterData & { groupBy?: string };
  remove: () => void;
  edit: () => void;
}) => {
  const specialConfig = specialConfigs[filter.id];

  const filterValue = Array.isArray(filter.value)
    ? filter.value.join(', ')
    : (filter.label ?? filter.value);

  const base = (
    <LightTag
      onClickIcon={specialConfig ? undefined : remove}
      onClick={specialConfig ? undefined : edit}
      iconLabel="Remove filter"
      icon={specialConfig ? <IconHelp /> : <IconClear />}
      iconPosition={specialConfig ? 'leading' : 'trailing'}
      tone={specialConfig ? 'secondary' : 'primary'}
    >
      {`${filterTypesMap.get(filter.type)!.label} ${comparatorNames[filter.comparator]} ${
        filterValue
      }`}
    </LightTag>
  );

  return specialConfig ? (
    <TooltipRenderer
      id="graphql-filter"
      tooltip={
        <Text weight="regular" size="small">
          {specialConfig.explanation(filter.groupBy!)}
        </Text>
      }
    >
      {({ triggerProps }) => (
        <Box {...triggerProps}>
          <Box pointerEvents="none">{base}</Box>
        </Box>
      )}
    </TooltipRenderer>
  ) : (
    base
  );
};
